<template>
  <mdb-container class="gp-has-header" v-if="formData">
  <mdb-card class="text-left">
    <mdb-card-header class="secondary-color text-white">
      <h4>{{ formData.name }}</h4>
    </mdb-card-header>
    <mdb-card-body v-if="!submitSuccess">
      <custom-data :custom-data="formData.fields" allow-edit force-edit help-text-as-label is-self
                   @dataSaved="formSaved"/>

    </mdb-card-body>
    <mdb-card-body v-if="submitSuccess">
      <h5>{{formData.confirmationText}}</h5>
    </mdb-card-body>
  </mdb-card>


  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import CustomData from "./common/CustomData";

import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer,} from 'mdbvue';

export default {
    name: 'Contact-Form',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      mdbBtn,
      CustomData
    },
    data() {
      return {
        submitSuccess: false,
        formData: null,
      }
    },
    computed: {
      loggedIn: function() {
        return this.$store.state.loggedIn
      },
      userDetails: function () {
        return this.$store.state.userDetails
      },
      settings: function () {
        return this.$store.state.settings
      }
    },
    mounted() {
      this.$store.dispatch("setExecuting", true)
      let url = "/customForm/loadResponse/" + this.$route.params.name
      api.get(url, this.message).then(
        (response) => {
          this.formData = response.data
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 6000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    methods: {
      formSaved(formData) {
        this.$store.dispatch("setExecuting", true)
        let url = "/customForm/saveResponse/" + this.formData.id
        api.post(url, {fields: formData}).then(
          (response) => {
            this.submitSuccess = true
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 6000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      }
    }

  };
</script>
